import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import { getMessageFromActions } from '../helpers';

export const useGetErrorResponseMessage = (prefix) => {
    const translate = useTranslations(prefix);

    return useCallback((error) => {
        const { data = {} } = error?.response || error || {};
        const { errorText, errorMessage, playerMessage, errorCode } = data;
        const spareMessage = errorText || errorMessage || playerMessage || translate('playtech.mobile.system.systemError', 'System error');
        const actionMessage = getMessageFromActions(error);
        const defaultMessage = actionMessage || spareMessage;

        return prefix ? translate(errorCode?.toString?.(), defaultMessage) : defaultMessage;
    }, [translate, prefix]);
};
